import React, { useState, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getStoredToken } from "../component/utils/getStoredToken";
import { imgurl } from "../baseurl";
import BottomMenu from "../component/BottomMenu";
import NavigateHome from "../component/utils/NavigateHome";
import PageCount from "../component/utils/PageCount";

const API_BASE = "https://chat.soulsathi.com";

const ChatMobile = () => {
  const token = getStoredToken();
  const [chatUsers, setChatUsers] = useState([]);
  const navigate = useNavigate();

  const loadChatList = async () => {
    try {
      const res = await axios.post(
        `${API_BASE}/chat/list`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setChatUsers(res.data);
    } catch (err) {
      console.error("Failed to load chat list:", err);
    }
  };

  useEffect(() => {
    loadChatList();
  }, []);

  return (

    <>
    <NavigateHome/>
    <PageCount pageName = {"Mobile Chat Page"}/>
    <div className="chat-mobile-container d-block d-lg-none">
      <div className="search-box">
        <FaSearch />
        <input type="text" placeholder="Search..." />
      </div>

      <div className="chat-list-mobile">
        {chatUsers.map((u) => (
          <div
  key={u.user_id}
  className="chat-list-item"
  onClick={() =>
    navigate(`/chat/${u.uid}`, { state: { user: u } })
  }
>
  <img src={imgurl + u.profile_photo} alt={u.display_id} />

  <div className="chat-info">
    <div className="chat-info-top">
      <h6>{u.display_id}</h6>

      {/* Time */}
      <span className="chat-time">
        {new Date(u.created_at).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        })}
      </span>
    </div>

    <div className="chat-info-bottom">
      <small className={u.read_status === false && u.sender_id !== u.user_id ? "unread-message" : ""}>
        {u.message || "Start chatting..."}
      </small>

      {/* Unread badge */}
      {u.read_status === false && u.sender_id !== u.user_id && (
        <span className="unread-count">●</span>
      )}
    </div>
  </div>
</div>

        ))}
      </div>
    </div>

<BottomMenu/>

    </>

  );
};

export default ChatMobile;
